module.exports = __webpack_public_path__ + "static/media/out_point_charge.b0031a13.svg";